import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setNewUI } from '../../../../store/orders/actions';
import { useMutationCall } from '../../../../api/react-client';
import { useClient } from '../../../../api/api-client';

const endpoint = 'permissions/set_ui_preference';

const SwitchUI = () => {
  const dispatch = useDispatch();
  const client = useClient();
  const isNewUI = useSelector((state) => state.ordersState?.isNewUI);

  const { mutate: setNewUIPreference } = useMutationCall(
    {},
    endpoint,
    ['set_ui_preference'],
    {
      doNotShowSuccessToast: true,
    },
    (is_new_ui_opted) =>
      client(endpoint, {
        data: {
          is_new_ui_opted,
        },
      }),
  );

  const handleSwitchUIClick = (event) => {
    dispatch(setNewUI(event.target.checked));
    setNewUIPreference(event.target.checked);
  };

  return (
    <div
      className={
        'tw-py-1 tw-flex tw-w-full tw-items-center tw-justify-between tw-border-solid tw-border-grey-200 tw-border-[1px] tw-border-x-0 tw-border-t-0 tw-pb-3 tw-font-medium tw-text-grey-700'
      }
    >
      <span>Enable New UI</span>
      <label className='switch tw-cursor-pointer'>
        <input
          type='checkbox'
          onChange={handleSwitchUIClick}
          checked={isNewUI}
        />
        <span className='slider round'></span>
      </label>
    </div>
  );
};

export default SwitchUI;
